import { 
  collection, 
  addDoc, 
  updateDoc,
  doc, 
  getDocs, 
  getDoc, 
  query, 
  orderBy 
} from 'firebase/firestore';
import { db } from '../config/firebase';

const COLLECTION_NAME = 'products';

export const createProduct = async (productData) => {
  try {
    console.log('Creating product with data:', productData);
    const docRef = await addDoc(collection(db, COLLECTION_NAME), productData);
    console.log('Product created with ID:', docRef.id);
    return { id: docRef.id, ...productData };
  } catch (error) {
    console.error('Error in createProduct:', error);
    throw new Error('Failed to create product: ' + error.message);
  }
};

export const updateProduct = async (id, productData) => {
  try {
    const productRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(productRef, productData);
    return { id, ...productData };
  } catch (error) {
    throw new Error('Failed to update product: ' + error.message);
  }
};

export const getProducts = async () => {
  try {
    console.log('Fetching products...');
    const productsRef = collection(db, COLLECTION_NAME);
    const q = query(productsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const products = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    
    console.log('Fetched products:', products);
    return products;
  } catch (error) {
    console.error('Error in getProducts:', error);
    throw new Error('Failed to fetch products: ' + error.message);
  }
};

export const getProduct = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() };
    } else {
      throw new Error('Product not found');
    }
  } catch (error) {
    throw new Error('Failed to fetch product: ' + error.message);
  }
};